module.exports = __webpack_public_path__ + "media/Night-vision.92cb3f39.mp4";